import { WatchlistId, WatchlistManager } from '@benzinga/watchlist-manager';
import { MenuNodeDef } from '@benzinga/widget-tools';
import React from 'react';
import { Watchlist } from '@benzinga/themed-icons';

export const watchlistContextOption = (ticker: string, watchlistManager: WatchlistManager): MenuNodeDef => {
  const watchlists = watchlistManager.getStoredWatchlists() ?? [];
  const watchlistAction = (wlID: WatchlistId) => () => {
    const wl = watchlistManager.getStoredWatchlistById(wlID);
    wl && watchlistManager.addTickersToWatchlist(wl, [ticker]);
  };
  const wlNodes = watchlists.flatMap<MenuNodeDef>(wl =>
    wl.name && !wl.symbols.some(symbol => symbol.symbol === ticker)
      ? [
          {
            action: watchlistAction(wl.watchlistId),
            icon: <Watchlist />,
            key: wl.watchlistId,
            name: wl.name.length > 25 ? wl.name.slice(0, 24) + '...' : wl.name,
            type: 'Item',
          },
        ]
      : [],
  );
  if (wlNodes.length === 0) {
    wlNodes.push({
      key: 'none',
      name: 'No Applicable Watchlists',
      type: 'Item',
    });
  }
  return {
    icon: (<Watchlist />) as React.ReactElement,
    key: 'watchlist',
    name: 'Add to Watchlist',
    nodes: wlNodes,
    type: 'SubMenu',
  };
};
